/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_DisappearsInputs */

const en_story_disappears = /** @type {(inputs: Story_DisappearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disappears in 24 hours`)
};

const es_story_disappears = /** @type {(inputs: Story_DisappearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desaparece en 24 horas`)
};

const fr_story_disappears = /** @type {(inputs: Story_DisappearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disparaît dans 24 heures`)
};

const de_story_disappears = /** @type {(inputs: Story_DisappearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verschwindet in 24 Stunden`)
};

const id_story_disappears = /** @type {(inputs: Story_DisappearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menghilang dalam 24 jam`)
};

/** @type {(inputs: Story_DisappearsInputs) => LocalizedString} */
const ja_story_disappears = en_story_disappears;

/** @type {(inputs: Story_DisappearsInputs) => LocalizedString} */
const zh_story_disappears = en_story_disappears;

/** @type {(inputs: Story_DisappearsInputs) => LocalizedString} */
const ar_story_disappears = en_story_disappears;

/** @type {(inputs: Story_DisappearsInputs) => LocalizedString} */
const it_story_disappears = en_story_disappears;

/** @type {(inputs: Story_DisappearsInputs) => LocalizedString} */
const ru_story_disappears = en_story_disappears;

/** @type {(inputs: Story_DisappearsInputs) => LocalizedString} */
const pt_story_disappears = en_story_disappears;

/** @type {(inputs: Story_DisappearsInputs) => LocalizedString} */
const ko_story_disappears = en_story_disappears;

/**
* | output |
* | --- |
* | "Disappears in 24 hours" |
*
* @param {Story_DisappearsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_disappears = /** @type {((inputs?: Story_DisappearsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_DisappearsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_disappears(inputs)
	if (locale === "es") return es_story_disappears(inputs)
	if (locale === "fr") return fr_story_disappears(inputs)
	if (locale === "de") return de_story_disappears(inputs)
	if (locale === "ja") return ja_story_disappears(inputs)
	if (locale === "zh") return zh_story_disappears(inputs)
	if (locale === "ar") return ar_story_disappears(inputs)
	if (locale === "id") return id_story_disappears(inputs)
	if (locale === "it") return it_story_disappears(inputs)
	if (locale === "ru") return ru_story_disappears(inputs)
	if (locale === "pt") return pt_story_disappears(inputs)
	return ko_story_disappears(inputs)
});